import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {isString} from 'lodash';
import isEmpty from 'is-empty';
import compressImage from '../../../utils/compress-image';
import {segmentEventTracker} from '../../../utils/SegmentEventTracker';
import {
  TrackEventName,
  PageViewName,
  PageName,
} from '../../shared/constants/SegmentEvents';

import {
  updatePurchaseOrderWithProgress,
  fetchPurchaseOrder,
  fetchPurchaseOrderAttachments,
  fetchPurchaseOrderNotifications,
  resolvePurchaseOrderNotifications,
} from '../purchaseOrdersActions';

import {
  fetchTradeSupportingDocuments,
} from '../../supporting_documents/actions';

import {CarouselProvider} from 'pure-react-carousel';
import Layout from '../../shared/components/layouts/MainLayout';
import ProgressBarContainer from '../../shared/components/forms/ProgressBarContainer';
import PageNotFound from '../../shared/components/notices/PageNotFound';
import FileInputButton from '../../shared/components/forms/FileInputButton';

import Notification from './TradeDocumentNotification';
import Status from '../components/TradeDocumentStatus';
import AttachmentsCarousel from '../components/AttachmentsCarousel';
import ContactsManagerContainer from '../../contacts/containers/WholeContactsManagerContainer';

class PurchaseOrderDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      loading: false,
      change_image_loading: false,
      append_image_loading: false,
      attachments: [],
      purchase_order: null,
      notification: null,
      show_notification: true,
      notFound: false,
      uploadProgress: 0,
    };
  }

  onFetchSuccess = response => {
    this.setState({purchase_order: response});

    this.props.dispatch(
      fetchTradeSupportingDocuments(
        this.props.user.id,
        'purchase_orders',
        this.purchaseOrderID,
        () => this.setState({loading: false}),
      ),
    );

    this.props.dispatch(
      fetchPurchaseOrderAttachments(
        this.purchaseOrderID,
        this.props.user.id,
        response => {
          this.setState({attachments: response});
        },
      ),
    );

    this.props.dispatch(
      fetchPurchaseOrderNotifications(
        this.purchaseOrderID,
        this.props.user.id,
        response => {
          this.setState({notification: response.pop()});
        },
      ),
    );
  };

  onFetchError = () => {
    this.setState({notFound: true});
  };

  componentDidMount() {
    this.setSegmentDetails();
    this.setState({loading: true});

    this.props.dispatch(
      fetchPurchaseOrder(
        this.purchaseOrderID,
        this.props.user.id,
        this.onFetchSuccess,
        this.onFetchError,
      ),
    );
  }

  setSegmentDetails() {
    segmentEventTracker.setContext({page_name: PageName.TRADE_DOC_DETAILS});
    segmentEventTracker.trackPageView(
      PageViewName.PURCHASE_ORDER_DETAILS_VIEWED,
    );
  }

  get purchaseOrderID() {
    const {id} = this.props.match.params;
    return id;
  }

  get purchaseOrder() {
    return this.state.purchase_order || {};
  }

  get purchaseOrderDocument() {
    return this.purchaseOrder.purchase_order_document || {};
  }

  get rejected() {
    if (!this.purchaseOrder || !this.purchaseOrder.purchase_order_document)
      return;
    return this.purchaseOrder.purchase_order_document.status === 'rejected';
  }

  replaceFilesData = files => {
    let formData = new FormData();
    formData.append(
      'purchase_order[purchase_order_document_attributes[id]]',
      this.state.purchase_order.purchase_order_document.id,
    );

    if (this.purchaseOrderDocument.status === 'resubmit') {
      formData.append(
        'purchase_order[purchase_order_document_attributes[status]]',
        'under verification',
      );
    }

    files.push.apply(files, this.state.attachments);
    files.forEach((file, index) => {
      formData.append(
        'purchase_order[purchase_order_document_attributes[purchase_order_attachments_attributes[][id]]]',
        file.id || '',
      );
      if (file instanceof Blob) {
        formData.append(
          'purchase_order[purchase_order_document_attributes[purchase_order_attachments_attributes[][attachment_file]]]',
          file,
          file.name,
        );
      } else {
        formData.append(
          'purchase_order[purchase_order_document_attributes[purchase_order_attachments_attributes[][_destroy]]]',
          true,
        );
      }
    });

    return formData;
  };

  addFilesData = files => {
    let formData = new FormData();
    formData.append(
      'purchase_order[purchase_order_document_attributes[id]]',
      this.state.purchase_order.purchase_order_document.id,
    );

    if (this.purchaseOrderDocument.status === 'resubmit') {
      formData.append(
        'purchase_order[purchase_order_document_attributes[status]]',
        'under verification',
      );
    }

    files.forEach((file, index) => {
      formData.append(
        'purchase_order[purchase_order_document_attributes[purchase_order_attachments_attributes[][attachment_file]]]',
        file,
        file.name,
      );
    });

    return formData;
  };

  onUploadProgress = e => {
    const uploadProgress = Math.round((e.loaded / e.total) * 100);
    this.setState({uploadProgress: uploadProgress});
  };

  sendUpdateData = (formData, action) => {
    this.props.dispatch(
      updatePurchaseOrderWithProgress(
        this.purchaseOrderID,
        this.props.user.id,
        formData,
        response => {
          const {purchase_order_attachments} = response.purchase_order_document;
          let purchase_order = {...this.state.purchase_order};

          purchase_order.purchase_order_document =
            response.purchase_order_document;
          this.setState({
            attachments: purchase_order_attachments,
            change_image_loading: false,
            append_image_loading: false,
            purchase_order: purchase_order,
          });
          this.resolveNotifications(action);
        },
        this.onUploadProgress,
      ),
    );
  };

  resolveNotifications = action => {
    const body = {fca_action: action};
    this.props.dispatch(
      resolvePurchaseOrderNotifications(
        body,
        this.purchaseOrderID,
        this.props.user.id,
        () => {
          const notif = this.state.notification;
          if (notif && notif.fca_action === action) {
            this.setState({show_notification: false});
          }
        },
      ),
    );
  };

  onFileChange = (e, replaceDoc = false) => {
    e.persist();
    const shouldReplaceDoc =
      e.target.name === 'replace_attachments' || replaceDoc;

    shouldReplaceDoc
      ? this.setState({uploadProgress: 10, change_image_loading: true})
      : this.setState({uploadProgress: 10, append_image_loading: true});

    const newFiles = Array.from(e.target.files);

    if (newFiles.length === 0) return;

    const promises = newFiles.map(file => {
      return compressImage(file)
        .catch(error => {
          return error.message;
        })
        .then(file => {
          return file;
        });
    });

    this.setState(
      {
        errors: {...this.state.errors, attachments: ''},
      },
      () => {
        Promise.all(promises).then(results => {
          const errors = {
            ...this.state.errors,
            attachments: results.filter(r => isString(r)).join(', '),
          };
          const files = results.filter(
            r => r instanceof File || r instanceof Blob,
          );

          if (isEmpty(errors.attachments)) {
            let formData;
            if (shouldReplaceDoc) {
              formData = this.replaceFilesData(files);
            } else {
              formData = this.addFilesData(files);
            }
            this.sendUpdateData(formData, e.target.name);
          } else {
            this.setState({errors}, () => {
              shouldReplaceDoc
                ? this.setState({
                    uploadProgress: 0,
                    change_image_loading: false,
                  })
                : this.setState({
                    uploadProgress: 0,
                    append_image_loading: false,
                  });
            });
          }
        });
      },
    );
  };

  renderUploadProgress() {
    if (!this.state.uploadProgress) return <div />;
    if (
      this.state.uploadProgress === 100 &&
      !this.state.change_image_loading && !this.state.append_image_loading
    )
      return <div />;

    return (
      <div
        className="position-absolute width-100p bottom-80 paddingLeft-m paddingRight-m"
        style={{height: '15px'}}>
        <ProgressBarContainer
          className="-full"
          progress={this.state.uploadProgress}
        />
      </div>
    );
  }

  addPageBtnName = () => {
    let btnName;
    if (
      this.state.notification &&
      this.state.notification.fca_action === 'incomplete_pages'
    ) {
      btnName = this.state.notification.fca_action;
    } else {
      btnName = 'add_attachments';
    }

    return btnName;
  };

  trackAddAttachments = () => {
    this.trackEvent(TrackEventName.PURCHASE_ORDER_ADD_FILES_CLICKED);
  };

  trackReplaceAttachments = () => {
    this.trackEvent(TrackEventName.PURCHASE_ORDER_REPLACE_FILES_CLICKED);
  };

  onClickResubmitDocument = () => {
    this.trackEvent(TrackEventName.RESUBMIT_TRADE_DOCUMENT_CLICKED);
  };

  renderAttachmentsCarousel = () => {
    return (
      <div className="ds-card ds-carousel">
        <CarouselProvider
          naturalSlideWidth={1}
          naturalSlideHeight={1}
          totalSlides={this.state.attachments.length}>
          <AttachmentsCarousel attachments={this.state.attachments} />
        </CarouselProvider>
        {this.renderUploadProgress()}
        {this.currentStep() < 2 && !this.rejected ? (
          <div className="ds-buttonGroup _parallelButtons actions --full">
            <FileInputButton
              multiple={true}
              className="--small"
              name="replace_attachments"
              accept="image/*,application/pdf"
              dataTestId="purchase-order-replace-attachments"
              buttonText="Replace files"
              onChange={this.onFileChange}
              ref="replace_attachments"
              onClick={this.trackReplaceAttachments}
            />
            <FileInputButton
              multiple={true}
              className="--small"
              name={this.addPageBtnName()}
              accept="image/*,application/pdf"
              dataTestId="purchase-order-add-more-pages"
              buttonText="Add more pages"
              onChange={this.onFileChange}
              ref="upload_attachments"
              onClick={this.trackAddAttachments}
            />
          </div>
        ) : null}
      </div>
    );
  };

  currentStep() {
    // returns integers 1-4 for easier tracking of steps
    if (!this.state.purchase_order) return;
    let {
      verified_at,
      verifying_buyer_started_at,
      verifying_document_started_at,
    } = this.state.purchase_order.purchase_order_document;

    if (
      !verified_at &&
      !verifying_buyer_started_at &&
      !verifying_document_started_at
    ) {
      return 1;
    } else if (
      !verified_at &&
      !verifying_buyer_started_at &&
      verifying_document_started_at
    ) {
      return 2;
    } else if (
      !verified_at &&
      verifying_buyer_started_at &&
      verifying_document_started_at
    ) {
      return 3;
    } else if (this.state.purchase_order.purchase_order_document.verified_at) {
      return 4;
    }
  }

  redirectToSupportingDocuments = () => {
    this.props.dispatch(
      push(
        `/purchase_orders/${this.props.match.params.id}/supporting_documents`,
      ),
    );
  };

  backButton = () => {
    this.trackEvent(TrackEventName.BACK_CLICKED);
    let route = {pathname: '/applications'};

    if (this.props.location.state) {
      route.state = {
        status: this.props.location.state.status,
        docType: this.props.location.state.docType,
      };
    }
    this.props.dispatch(push(route));
  };

  supportingDocImage = attachment => {
    return attachment.attachment_file_content_type === 'application/pdf' ? (
      <span className="material-icons color-red">picture_as_pdf</span>
    ) : (
      <img src={attachment.url} alt="supporting document" />
    );
  };

  renderSupportingDocuments = () => {
    if (!this.props.trade_supporting_documents) return;

    return (
      <div className="ds-card">
        <section className="cardTitle"> Supporting Documents </section>
        <section className="cardSection">
          <ul className="_list _square _noButton _noPadding --small">
            {this.props.trade_supporting_documents.length === 0 && (
              <li>
                <p className="byline -secondary _alignCenter">
                  No supporting documents attached yet
                </p>
              </li>
            )}
            {this.props.trade_supporting_documents.map(doc => {
              let primaryAttachment = doc.trade_supporting_attachments[0];

              return (
                <li key={`supporting-doc-${doc.id}`}>
                  {this.supportingDocImage(primaryAttachment)}
                  <div className="meta">
                    <p className="bit _normalCase _normalSpacing">
                      {' '}
                      {primaryAttachment.name}{' '}
                    </p>
                    <p className="byline"> {doc.description} </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </section>
        {!this.rejected && this.currentStep() !== 4 && (
          <section className="cardSection _simple _withColumns _noMinHeight --micro">
            <div className="text _noPadding _widthAuto">
              <p className="byline">
                Add supporting document(s) for this transaction
              </p>
            </div>
            <button
              className="ds-btn --micro -success _widthAuto"
              data-testid="add-supporting-documents"
              onClick={this.onAddSupportingDocuments}>
              {this.props.trade_supporting_documents.length > 1
                ? 'Add Another'
                : 'Add'}
            </button>
          </section>
        )}
      </div>
    );
  };

  onClickAddContact = e => {
    this.refs.contacts &&
      this.refs.contacts.getWrappedInstance().onClickAddContactButton(e);
  };

  onAddSupportingDocuments = () => {
    this.trackEvent(TrackEventName.ADD_TRADE_SUPPORTING_DOCUMENTS_CLICKED);
    this.redirectToSupportingDocuments();
  };

  statusPayload = () => {
    let purchaseOrderDocument = this.state.purchase_order
      .purchase_order_document;
    if (purchaseOrderDocument.status === 'resubmit') {
      return {
        status: purchaseOrderDocument.status,
        resubmit_reason: purchaseOrderDocument.reason,
      };
    }
    return {};
  };

  trackEvent = name => {
    segmentEventTracker.trackEvent(name, this.statusPayload());
  };

  renderFileInputErrors = () => {
    if (isEmpty(this.state.errors.attachments)) return;

    return (
      <div className="display-flex justifyContent-center alignItems-center paddingTop-s">
        <span className="fontSize-s color-red">
          {this.state.errors.attachments}
        </span>
      </div>
    );
  };

  render() {
    if (this.state.notFound) return <PageNotFound url="/purchase_orders" />;

    return (
      <Layout
        backButtonLabel="Purchase Order Details"
        backButtonAction={this.backButton}>
        <div className="ds-cardList">
          <Notification
            show={this.state.show_notification}
            notification={this.state.notification}
            tradeDocument={this.state.purchase_order}
            tradeDocumentType="purchase_order"
            errors={this.state.errors}
            redirectToSupportingDocuments={this.redirectToSupportingDocuments}
            onClickResubmitDocument={this.onClickResubmitDocument}
            onClickAddContactButton={
              this.refs.contacts &&
              this.refs.contacts.getWrappedInstance().onClickAddContactButton
            }
            onFileChange={this.onFileChange}
          />

          {this.renderAttachmentsCarousel()}
          {this.renderFileInputErrors()}

          <Status
            currentStep={this.currentStep()}
            tradeDocument={this.state.purchase_order}
            tradeDocumentType="purchase_order"
          />

          <ContactsManagerContainer
            ref="contacts"
            user_id={this.props.user.id}
            trade_id={this.purchaseOrderID}
            trade_type="PurchaseOrder"
            resolveNotifications={this.resolveNotifications}
            hidden={this.currentStep() === 4 || this.rejected}
            fca_action={
              this.state.notification && this.state.notification.fca_action
            }
            trackEvent={this.trackEvent}
          />

          {this.renderSupportingDocuments()}
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    purchase_orders: state.purchase_orders,
    trade_supporting_documents: state.trade_supporting_documents,
    user: state.user,
  };
};

export default connect(mapStateToProps)(PurchaseOrderDetails);



// WEBPACK FOOTER //
// ./src/features/trade_documents/containers/PurchaseOrderDetails.js